import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(shop)/layout.tsx");
